module.exports = __webpack_public_path__ + "static/media/29FUNOV15.e4ae4e57.jpg";